module.exports = __webpack_public_path__ + "img/7.2b9a0688.png";